import React from 'react';
import profileService from '../../services/profileService';

export default class Forgot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            message: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            error: null
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        const { email } = this.state;
        if (this.validateForm()) {
            profileService.forgotPassword(email)
                .then(response => {
                    this.setState({
                        message: 'Email with link to reset password is sent to your email!'
                    })
                }).catch(error => {
                });
        } else {
            this.setState({ error: "Email is required!" })
        }

    }

    validateForm() {
        return this.state.email;
    }

    render() {
        const { email, message, error } = this.state;
        return (
            <div className="auth-page-container container-fluid">
                <div className="auth-frame jumbotron">
                    <div className="auth-img-box ">
                        <img
                            className="auth-logo"
                            src='/assets/images/logo.png'
                            alt="AirTouch logo"
                        />
                    </div>
                    {!message ?
                        <form onSubmit={this.handleSubmit} className="text-left">
                            <div className="form-group">
                                <label htmlFor="email">Enter email:</label>
                                <input id='email' className="form-control" type="text" name="email" value={email} onChange={this.handleChange} />
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                            <div className="text-right">
                                <button type="submit" className="btn btn-lightblue">Send</button>
                            </div>
                        </form> : <div className={'alert alert-info'}>{message}</div>
                    }
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/forgotPassword/forgot.js